export default Engine =>
    class LadderMartingale extends Engine {
        moneyManagementParams = {
            stake  : 0.35,
            initial: 0.35,
            factor : 1.05,
            limit  : 1,
            profit : 0,
        };
        ladderMartingaleAfterPurchase(profit) {
            this.moneyManagementParams.profit += profit;

            if (this.moneyManagementParams.profit < this.moneyManagementParams.limit) {
                this.moneyManagementParams.stake = this.moneyManagementParams.stake * this.moneyManagementParams.factor;
            } else {
                this.ladderMartingaleReset();
            }
        }

        ladderMartingaleStake = () => this.moneyManagementParams.stake;

        ladderMartingaleTradeDefinitions(args) {
            this.moneyManagementParams = args;
            this.moneyManagementParams.stake = args.initial;
            this.ladderMartingaleReset();
        }

        ladderMartingaleReset() {
            this.moneyManagementParams.profit = 0;
            this.moneyManagementParams.stake = this.moneyManagementParams.initial;
        }
    };
